module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"売上高/坪"}}')
  delete Component.options._Ctor
}
